import axios from "axios";
import { BASE_URL } from "../constants";

/**
 * Decodes JWT token to extract user ID
 * @param {string} token - JWT token
 * @returns {string|null} - User ID or null if not found
 */
const getUserIdFromToken = (token) => {
  try {
    if (!token) return null;
    
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const decoded = JSON.parse(jsonPayload);
    return decoded.sub || decoded.jti || decoded.nameid || null;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

/**
 * Logs a print action to the audit trail
 * @param {string} entityId - The ID of the entity (job/PO) being printed
 * @param {string} documentName - The name of the document being printed
 * @param {object} userProfile - The user profile object from context
 * @returns {Promise} - Promise that resolves when the action is logged
 */
export const logPrintAction = async (entityId, documentName, userProfile) => {
  try {
    console.log("User profile:", userProfile); // Debug log to see what's available
    
    // Try multiple ways to get user ID
    let userId = userProfile.id || userProfile.ID;
    
    // If no direct ID, try to extract from JWT token
    if (!userId && userProfile.token) {
      userId = getUserIdFromToken(userProfile.token);
    }
    
    // If still no ID, use a fallback (you might want to use username or email)
    if (!userId) {
      userId = userProfile.username || userProfile.email || "system";
    }
    
    const userDisplayName = userProfile.displayname || userProfile.username || 'Unknown User';
    
    const payload = {
      entityId,
      documentName,
      userId: userId.toString(),
      userDisplayName
    };
    
    console.log("Sending audit payload:", payload);
    
    await axios.post(`${BASE_URL}/api/Audit/print`, payload);
    
    // Trigger audit refresh if the function exists
    if (window.refreshAuditData) {
      window.refreshAuditData();
    }
  } catch (error) {
    console.error("Error logging print action:", error);
    console.error("Error details:", error.response?.data);
    // Don't throw error as this is a background operation
  }
};
